import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ActivityLabelFilterSelect } from '@web/components/Filters/Elements/ActivityLabel';
import { AppsFilterSelect } from '@web/components/Filters/Elements/Apps';
import { StickyFilters } from '@web/components/Filters/StickyFilters';
import { ActivityLabelTargetEnum } from '@workalizer/shared/enums';
var EventsFilters = function () {
    return (_jsx(StickyFilters, { orgUnits: { resetUserOnAll: true }, additionalFilters: _jsxs(_Fragment, { children: [_jsx(ActivityLabelFilterSelect, { labelTargets: [
                        ActivityLabelTargetEnum.EVENT_NAMES,
                        ActivityLabelTargetEnum.ALL
                    ] }), _jsx(AppsFilterSelect, {})] }) }));
};
export default EventsFilters;
